const RETRO_DEFS = [
  { value: 'went_good',  title: 'What Went Good' },
  { value: 'went_bad',   title: 'What Went Bad' },
  { value: 'do_better',  title: 'What Should Be Done Better' },
];

export const RETRO_COLUMNS        = RETRO_DEFS.map((r) => ({ status: r.value, title: r.title }));
export const RETRO_STATUS_OPTIONS = RETRO_DEFS.map((r) => ({ value: r.value, label: r.title }));
export const RETRO_TITLE_COLORS   = { went_good: '#34d399', went_bad: '#f87171', do_better: '#fbbf24' };
